"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNestedQueryString = void 0;
function toNestedQueryString(params) {
    var esc = encodeURIComponent;
    var build = function (key, value) {
        if (typeof value === "object" && value !== null) {
            return Object.entries(value).flatMap(function (_a) {
                var k = _a[0], v = _a[1];
                return build("".concat(key, "[").concat(k, "]"), v);
            });
        }
        return ["".concat(esc(key), "=").concat(esc(value))];
    };
    var query = Object.entries(params)
        .flatMap(function (_a) {
        var key = _a[0], value = _a[1];
        return build(key, value);
    })
        .join("&");
    return query ? "?".concat(query) : "";
}
exports.toNestedQueryString = toNestedQueryString;
